import { useEffect, useRef } from 'react';

export const useToastAutoClose = ({ toasts, setToasts, autoCloseTime, autoClose }) => {
    const processedRef = useRef(new Set());
    const timeoutsRef = useRef({});

    useEffect(() => {
        // Don't do anything if autoClose is disabled
        if (!autoClose) return;

        // Find all active toasts that haven't been processed yet
        Object.values(toasts).forEach((toastList) => {
            toastList.forEach((toast) => {
                if (!toast.isActive) return;
                if (processedRef.current.has(toast.id)) return;
                if (toast.autoClose === false) return;

                processedRef.current.add(toast.id);

                const timeoutDuration =
                    typeof toast.autoClose === 'number' ? toast.autoClose : autoCloseTime;

                timeoutsRef.current[toast.id] = setTimeout(() => {
                    delete timeoutsRef.current[toast.id];
                    processedRef.current.delete(toast.id);

                    setToasts((prevToasts) =>
                        Object.entries(prevToasts).reduce((obj, [key, value]) => {
                            obj[key] = value.map((current) => {
                                if (current.id === toast.id) {
                                    return current.isActive
                                        ? { ...current, isActive: false }
                                        : current;
                                }
                                return current;
                            });
                            return obj;
                        }, {}),
                    );
                }, timeoutDuration);
            });
        });
    }, [toasts, setToasts, autoCloseTime, autoClose]);

    // Cleanup all timeouts on unmount
    useEffect(() => {
        const timeouts = timeoutsRef.current;
        return () => {
            Object.values(timeouts).forEach(clearTimeout);
        };
    }, []);
};
